import BigNumber from 'bignumber.js';
import { milliseconds } from 'date-fns';
import { erc20ABI } from 'wagmi';

import EthereumWallet, {
  EthereumAddress,
} from '#/features/ethereum-wallet/wallet';
import { BridgedToken } from '#/features/paraclear';

import { toQuantums } from '#/utils/quantums';

export async function readBridgeAllowance(
  token: BridgedToken,
  ethereumAddress: EthereumAddress,
): Promise<BigNumber> {
  const owner = ethereumAddress;
  const spender = token.l1BridgeAddress;
  const result = await EthereumWallet.readContract({
    address: token.l1TokenAddress,
    abi: erc20ABI,
    functionName: 'allowance',
    args: [owner, spender],
  });

  const allowance = BigNumber(result.toString());
  if (!allowance.isFinite()) {
    throw new TypeError(
      'Result of ERC20 Request Allowance is not a numeric value',
    );
  }

  return allowance;
}

export async function requestBridgeAllowanceIncrease(
  token: BridgedToken,
  ethereumAddress: EthereumAddress,
  amount: string,
): Promise<{ hash: string }> {
  const spender = token.l1BridgeAddress;
  const value = toQuantums(amount, token.decimals).toString();

  const { request } = await EthereumWallet.prepareWriteContract({
    address: token.l1TokenAddress,
    abi: erc20ABI,
    functionName: 'approve',
    args: [spender, BigInt(value)],
    /* the account to send the transaction from. */
    account: ethereumAddress,
  });

  const { hash } = await EthereumWallet.writeContract(request);
  // WIP: setup global default timeout for `waitForTransaction` inside EthereumWallet implementation?
  await EthereumWallet.waitForTransaction({
    hash,
    timeout: milliseconds({ minutes: 2 }),
  });

  return { hash };
}
